import React, { useEffect, useState } from 'react';
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import HttpsIcon from "@material-ui/icons/Https";
import { useHistory } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import withUrlParams from "../../../HOC/withUrlParams";
import i18n from 'i18next';
import { useRecoilValue } from "recoil";
import { isOnlineState } from "../../../../states/states";

const LessonItem = ({ myLessons, uuid }) => {

    const [showMessage, setShowMessage] = useState(false);
    const isOnline = useRecoilValue(isOnlineState);
    let history = useHistory();

    console.log("myLesson", myLessons)



    useEffect(() => {
        if (myLessons)
            myLessons.lessons.forEach((myLesson, index) => {
                if (myLesson.isPassed) {
                    if (document.getElementsByClassName('lesson-left')[index]) {
                        document.getElementsByClassName('lesson-left')[index].classList.remove('key-number');
                    }
                }
            })
    }, [myLessons]);

    if (!myLessons.lessons.length) {
        return (
            <h6 className="no-lessons"><p>{i18n.t('not_lesson_yet')}.</p></h6>
        )
    }

    return (
        <ul className="box-lesson">
            {myLessons ? myLessons.lessons.map((myLesson, index) => {
                return (
                    <li className="item-lesson"
                        key={index}
                        onClick={() => {
                            if (myLesson.learnAble && isOnline) {
                                history.push(`/start?uuid=${uuid}&curr_code=${myLesson.currCode}&lesson_code=${myLesson.lessonCode}`);
                            }
                            if (isOnline) {
                                setShowMessage(true);
                            }
                        }}>
                        <div className="lesson-left key-number">
                            {index + 1}
                        </div>
                        <div className="lesson-center">
                            <span>{myLesson.name}</span>
                        </div>
                        <div className="lesson-right">
                            <span className="margin-top"><ChevronRightIcon /></span>
                            {myLesson.learnAble && myLesson.isPassed
                                ? <span className="key">{myLesson.completedQuestions > myLesson.numberOfQuestions ? myLesson.numberOfQuestions : myLesson.completedQuestions}/{myLesson.numberOfQuestions}</span>
                                : myLesson.learnAble && !myLesson.isPassed ? ""
                                    : <span className="key"><HttpsIcon /></span>
                            }
                        </div>
                    </li>
                )
            }) : <></>}
            <div className={"timeOutSweetAlert"}>
                <SweetAlert
                    show={showMessage}
                    title=""
                    confirmBtnText={i18n.t('confirm')}
                    confirmBtnBsStyle="primary"
                    openAnim={{ name: 'showSweetAlert', duration: 500 }}
                    btnSize="sm"
                    onConfirm={() => {
                        setShowMessage(false);
                    }}
                    onCancel={() => {
                        setShowMessage(false);
                    }}
                >
                    {i18n.t('completed_prerequisite_lessons')}
                </SweetAlert>
            </div>
        </ul>
    )
};

export default withUrlParams(LessonItem);
